import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0F0F0",
      d: "M13.999 25.666c6.443 0 11.666-5.223 11.666-11.666S20.442 2.333 14 2.333 2.332 7.556 2.332 14c0 6.443 5.223 11.666 11.667 11.666"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D80027",
      d: "M13.492 14h12.174c0-1.053-.14-2.074-.402-3.044H13.492zM13.492 7.913h10.462a11.7 11.7 0 0 0-2.692-3.044h-7.77zM14 25.666c2.746 0 5.27-.949 7.263-2.536H6.738a11.62 11.62 0 0 0 7.263 2.536M4.045 20.087h19.908a11.6 11.6 0 0 0 1.31-3.044H2.735a11.6 11.6 0 0 0 1.31 3.044"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0052B4",
      d: "M7.736 4.155H8.8l-.989.718.378 1.163-.989-.719-.989.719.327-1.004a11.7 11.7 0 0 0-2.263 2.521h.34l-.629.458q-.147.245-.282.498l.3.925-.56-.407q-.21.443-.382.906l.331 1.019h1.223l-.99.719.378 1.162-.988-.718-.593.43q-.09.715-.09 1.455h11.667V2.333c-2.305 0-4.453.669-6.263 1.822m.452 8.678-.989-.718-.989.718.378-1.162-.989-.719h1.223l.377-1.162.378 1.162H8.8l-.989.719zM7.81 8.272l.378 1.162-.989-.718-.989.718.378-1.162-.989-.719h1.223l.377-1.162.378 1.162H8.8zm4.563 4.561-.989-.718-.989.718.378-1.162-.989-.719h1.222l.378-1.162.378 1.162h1.222l-.989.719zm-.378-4.561.378 1.162-.989-.718-.989.718.378-1.162-.989-.719h1.222l.378-1.162.378 1.162h1.222zm0-3.399.378 1.163-.989-.719-.989.719.378-1.163-.989-.718h1.222l.378-1.163.378 1.163h1.222z"
    }, null, -1)
  ])))
}
export default { render: render }